import React, { Component } from "react";
import axios from "axios";
import { v4 as uuid } from "uuid";
import FilteredMultiSelect from "./FilteredMultiSelect";
import QuizPack from "./QuizPack";

const config = require("../config.json");

export default class QuizPackAdmin extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  state = {
    newQuizPack: {
      id: uuid(),
      packName: "",
      quizzes: [],
    },
    quizPacks: [],
    quizzes: [],
    selectedQuizzes: [],
    loading: false,
  };

  handleAddQuizPack = async (quizPack, event) => {
    event.preventDefault();
    try {
      const params = {
        id: quizPack.id,
        quizzes: this.state.selectedQuizzes.map((quiz) => quiz.id),
        packName: quizPack.packName,
      };

      await axios.post(
        `${config.api.invokeUrl}/quiz/packs/${quizPack.id}`,
        params
      );
      this.setState({
        quizPacks: [...this.state.quizPacks, this.state.newQuizPack],
        selectedQuizzes: [],
      });
      this.setState({
        newQuizPack: {
          id: uuid(),
          quizzes: [],
          packName: "",
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  handleUpdateQuizPack = async (quizPack, quizzes) => {
    quizPack.quizzes = quizzes.map((quiz) => quiz.id);

    try {
      const params = {
        id: quizPack.id,
        quizzes: quizPack.quizzes,
        packName: quizPack.packName,
      };
      await axios.patch(
        `${config.api.invokeUrl}/quiz/packs/${quizPack.id}`,
        params
      );
    } catch (err) {
      console.log(err);
    }

    const updatedQuizPacks = [...this.state.quizPacks].filter(
      (c) => c.id !== quizPack.id
    );
    updatedQuizPacks.push(quizPack);
    this.setState({ quizPacks: updatedQuizPacks });
  };

  handleDeleteQuizPack = async (id, event) => {
    event.preventDefault();
    if (window.confirm("Er du sikker?")) {
      try {
        await axios.delete(`${config.api.invokeUrl}/quiz/packs/${id}`);
      } catch (err) {
        console.log(err);
      }
      const updatedQuizPacks = [...this.state.quizPacks].filter(
        (quizPack) => quizPack.id !== id
      );
      this.setState({ quizPacks: updatedQuizPacks });
    }
  };

  fetchQuizPacks = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/quiz/packs`);
      const quizPacks = res.data;
      this.setState({ quizPacks: quizPacks });
    } catch (err) {
      console.log(err);
    }
  };

  fetchQuizzes = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/quiz`);
      const quizzes = res.data;
      this.setState({ quizzes: quizzes });
    } catch (err) {
      console.log(err);
    }
  };

  handleDeselectQuiz(index) {
    var selectedQuizzes = this.state.selectedQuizzes.slice();
    selectedQuizzes.splice(index, 1);
    this.setState({ selectedQuizzes });
  }

  handleQuizSelectionChange = (selectedQuizzes) => {
    this.setState({ selectedQuizzes });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      newQuizPack: {
        ...this.state.newQuizPack,
        [name]: value,
      },
    });
  }

  componentDidMount = () => {
    this.fetchAll();
  };

  fetchAll = async () => {
    this.setState({ loading: true });
    let promise = await Promise.all([
      this.fetchQuizzes(),
      this.fetchQuizPacks(),
    ]);
    this.setState({ loading: false });
  };

  render() {
    return !this.state.loading ? (
      <>
        <p className="subtitle is-5">Tilføj og fjern Quizpakker</p>
        <br />
        <div className="columns is-multiline is-flex-direction-column">
          <div className="column is-full">
            <form
              onSubmit={(event) =>
                this.handleAddQuizPack(this.state.newQuizPack, event)
              }
            >
              <div className="control">
                <input
                  className="input is-medium"
                  type="text"
                  name="packName"
                  placeholder="Indtast navn"
                  required
                  value={this.state.newQuizPack.packName}
                  onChange={this.handleInputChange}
                />
                <div className="column is-flex is-flex-direction-row">
                  <div className="column is-half">
                    Vælg Quizzer
                    <FilteredMultiSelect
                      onChange={this.handleQuizSelectionChange}
                      options={this.state.quizzes}
                      selectedOptions={this.state.selectedQuizzes}
                      textProp="quizName"
                      valueProp="id"
                      className="activity-selector"
                      placeholder="søg"
                      buttonText="vælg"
                    />
                    {this.state.selectedQuizzes.length === 0 && (
                      <p>(intet valgt endnu)</p>
                    )}
                    {this.state.selectedQuizzes.length > 0 && (
                      <ul>
                        {this.state.selectedQuizzes.map((quiz, i) => (
                          <li key={quiz.id}>
                            {`${quiz.quizName} ${quiz.category}`}
                            <button
                              type="button"
                              onClick={() => this.handleDeselectQuiz(i)}
                            >
                              &times;
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
                <button type="submit" className="button is-primary is-medium">
                  Tilføj
                </button>
              </div>
            </form>
          </div>
          <div className="column">
            <div className="tile is-ancestor ">
              <div className="tile is-parent flex-wrap">
                {this.state.quizPacks.map((quizPack) => (
                  <QuizPack
                    handleUpdateQuizPack={this.handleUpdateQuizPack}
                    handleDeleteQuizPack={this.handleDeleteQuizPack}
                    quizPack={quizPack}
                    quizzes={this.state.quizzes}
                    key={quizPack.id}
                    isAdmin={true}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </>
    ) : (
      <></>
    );
  }
}
